/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `AvatarSize*`'s.
 */
export type AvatarSize =
  | AvatarSizeLarge
  | AvatarSizeMedium
  | AvatarSizeSmall
  | AvatarSizeExtraSmall
  | AvatarSizeExtraExtraSmall;

/**
 * The Avatar large type.
 */
export type AvatarSizeLarge = typeof AVATAR_SIZE_LARGE;

/**
 * The Avatar medium type.
 */
export type AvatarSizeMedium = typeof AVATAR_SIZE_MEDIUM;

/**
 * The Avatar small type.
 */
export type AvatarSizeSmall = typeof AVATAR_SIZE_SMALL;

/**
 * The Avatar extra small type.
 */
export type AvatarSizeExtraSmall = typeof AVATAR_SIZE_EXTRA_SMALL;

/**
 * The Avatar extra small type.
 */
export type AvatarSizeExtraExtraSmall = typeof AVATAR_SIZE_EXTRA_EXTRA_SMALL;

/**
 * The Avatar large constant.
 */
export const AVATAR_SIZE_LARGE = `lg`;

/**
 * The Avatar medium constant.
 */
export const AVATAR_SIZE_MEDIUM = `md`;

/**
 * The Avatar small constant.
 */
export const AVATAR_SIZE_SMALL = `sm`;

/**
 * The Avatar extra small constant.
 */
export const AVATAR_SIZE_EXTRA_SMALL = `xs`;

/**
 * The Avatar extra extra small constant.
 */
export const AVATAR_SIZE_EXTRA_EXTRA_SMALL = `xxs`;
